'use client'

import { usePathname } from 'next/navigation'
import { ChevronRight, FileText } from 'lucide-react'
import { navigateUrl } from '@/utils/client-request'

export default function About({ vendor }: { vendor?: any }) {
  const pathname = usePathname()
  const vendorName = vendor?.name || 'Дэлгүүр'
  const aboutHtml: string | null = vendor?.about || null

  return (
    <div>
      <div className="mx-auto w-full max-w-[1280px] px-4 lg:px-8 pt-10 pb-12" style={{ borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
        <div className="hidden md:flex items-center gap-1.5 text-[12px] mb-8" style={{ color: 'rgba(255,255,255,0.55)' }}>
          <a href={navigateUrl('/', pathname)} className="hover:text-white transition-colors">Нүүр</a>
          <ChevronRight className="h-3 w-3" style={{ opacity: 0.5 }} />
          <span className="text-white font-medium">Бидний тухай</span>
        </div>
        <div className="text-[10px] font-semibold uppercase tracking-[0.22em]" style={{ color: '#a8a8b3' }}>Бидний тухай</div>
        <h1
          className="mt-3 font-semibold tracking-[-0.03em] leading-[0.95] max-w-3xl text-white"
          style={{ fontFamily: 'Gilroy, Inter, sans-serif', fontSize: 'clamp(40px, 8vw, 76px)' }}
        >
          {vendorName}.
        </h1>
        {vendor?.description && (
          <p className="mt-5 text-[15px] leading-7 max-w-xl" style={{ color: 'rgba(255,255,255,0.6)' }}>
            {vendor.description}
          </p>
        )}
      </div>

      <div className="mx-auto w-full max-w-[1280px] px-4 lg:px-8 pt-14 pb-20">
        <div className="max-w-3xl">
          {aboutHtml ? (
            <div className="dark-editorial-prose" dangerouslySetInnerHTML={{ __html: aboutHtml }} />
          ) : (
            <div className="rounded-2xl p-10 text-center" style={{ border: '1px dashed rgba(255,255,255,0.14)' }}>
              <FileText className="h-10 w-10 mx-auto mb-3" style={{ color: 'rgba(255,255,255,0.4)' }} />
              <p className="text-[14px]" style={{ color: 'rgba(255,255,255,0.55)' }}>Одоогоор бидний тухай мэдээлэл нэмэгдээгүй байна.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
